import '../../../core/components/app-root/AppRoot.css';
import '../../../core/styles/diagnostic-tooltip.css';
import '../../base-code-editor/BaseCodeEditor.css';
import './SuggestionsInfoSection.css';
export var container = '_1pyam7v1-3-15-1';
export var shortcutLabel = '_1pyam7v3-3-15-1';
export var shortcutsGroup = '_1pyam7v2-3-15-1';